"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hoursMinutesSecondsTranslations = {
    "en": {
        hours: "h",
        minutes: "m",
        seconds: "s",
    },
    "nl": {
        hours: "u",
        minutes: "m",
        seconds: "s",
    },
    "ja": {
        hours: "時間",
        minutes: "分",
        seconds: "秒",
    },
    "it": {
        hours: "h",
        minutes: "m",
        seconds: "s",
    },
    "fr": {
        hours: "h",
        minutes: "m",
        seconds: "s",
    },
    "es": {
        hours: "h",
        minutes: "m",
        seconds: "s",
    },
    "en-GB": {
        hours: "h",
        minutes: "m",
        seconds: "s",
    },
    "de": {
        hours: "h",
        minutes: "m",
        seconds: "s",
    },
    "ru": {
        hours: "ч",
        minutes: "м",
        seconds: "с",
    },
};
